import styles from "../styles/HeaderShortcuts.module.scss";
import FontAwesome from "../../utilities/FontAwesome";
import NavigationLink from "../navigation/NavigationLink";
import { Flex, IconButton } from "@radix-ui/themes";

type EditableProps = {
  canEdit: true;
  deleteNavigation: (id: number) => void;
  updateNavigation: (navigation: Navigation) => void;
};

type NonEditableProps = {
  canEdit: false;
};

export function Shortcut(
  props: {
    shortcut: Navigation;
    className?: string;
  } & (EditableProps | NonEditableProps),
) {
  return (
    <li className={props.className}>
      <div className={styles.editControls}>
        {props.canEdit && (
          <Flex gap={"2"} justify={"center"}>
            <IconButton
              size={"2"}
              title={"Edit Link"}
              aria-label={"Edit Link"}
              onClick={() => props.updateNavigation(props.shortcut)}
            >
              <FontAwesome ariaHidden name={"fa-pen"} prefix={"fas"} />
            </IconButton>
            <IconButton
              size={"2"}
              color={"red"}
              title={"Delete Link"}
              aria-label={"Delete Link"}
              onClick={() => props.deleteNavigation(props.shortcut.id)}
            >
              <FontAwesome ariaHidden name={"fa-trash"} prefix={"fas"} />
            </IconButton>
          </Flex>
        )}
      </div>
      <NavigationLink
        href={props.shortcut.url}
        navigationObj={props.shortcut}
        aria-label={props.shortcut.title}
        className={styles.link}
      >
        <FontAwesome
          fixedWidth
          name={props.shortcut.icon}
          ariaHidden={true}
          className={styles.glyph}
        />
        <div className={styles.label}>
          <div>{props.shortcut.title}</div>
        </div>
      </NavigationLink>
    </li>
  );
}
